export const locale = {
  lang: 'it',
  data: {
    WALLET: 'Storico operazioni wallet',
    EXPORT: 'Esporta',
    EXPORT_CSV: 'Esporta come CSV',
    EXPORT_XLS: 'Esporta come XLS',
    DATA: 'Data',
    REASON: 'Causale',
    INVOICE_ID: 'ID Fattura',
    TYPE: 'Tipo',
    DEBT_AMOUNT: 'Importo Deb. (-)',
    CREDIT_AMOUNT: 'Importo Cred. (+)',
    CLOSE: 'Chiudi',
  },
};
